import { render, staticRenderFns } from "./1_greetings.vue?vue&type=template&id=8134e1c2&scoped=true&"
import script from "./1_greetings.vue?vue&type=script&lang=js&"
export * from "./1_greetings.vue?vue&type=script&lang=js&"
import style0 from "./1_greetings.vue?vue&type=style&index=0&id=8134e1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8134e1c2",
  null
  
)

export default component.exports